document.addEventListener("DOMContentLoaded", function() {
  var $touchContents = document.querySelectorAll(".js-qaArrow dt");
  document.getElementsByClassName("js-qaArrow")[0].setAttribute("data-isjsloaded", "false");

  // イベント多重登録防止のため、js読込フラグをチェック
  if (document.getElementsByClassName("js-qaArrow")[0].getAttribute("data-isjsloaded") === "false") {

    // クリックイベントを各dtに付与する
    for (var index = 0; index < $touchContents.length; index++) {
      $touchContents[index].addEventListener("click", toggleContent);
    }

    // js読込フラグを立てる
    document.getElementsByClassName("js-qaArrow")[0].setAttribute("data-isjsloaded", "true");
  }

  // クリック箇所に表示、非表示用クラスを付与する
  function toggleContent(e) {
    var $this = e.currentTarget,
      $arrow = $this.querySelector(".arrow"),
      $nextDd = $this.nextElementSibling,
      isHidden = $nextDd.classList.contains("item__dd--hide");

    if (isHidden) {
      $this.classList.add("anime1");
      $arrow.classList.add("open");
      $nextDd.classList.add("item__dd--show", "open");

      $this.classList.remove("anime2");
      $nextDd.classList.remove("item__dd--hide");

    } else {
      $this.classList.add("anime2");
      $nextDd.classList.add("item__dd--hide");

      $this.classList.remove("anime1");
      $arrow.classList.remove("open");
      $nextDd.classList.remove("item__dd--show", "open");
    }
  }
});
